import { render, staticRenderFns } from "./VaChip.demo.vue?vue&type=template&id=431b7788&"
import script from "./VaChip.demo.vue?vue&type=script&lang=js&"
export * from "./VaChip.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports